export class SaleOfferLineOther {
  constructor(
    public hash?: string,
    public concept?: string,
    public amount?: number
  ) { }

  clone() {
    return new SaleOfferLineOther(
      this.hash,
      this.concept,
      this.amount
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/sale-offer-line-other.ts